'use client';

import { useTranslation } from '@/i18n/client';
import { EventFilterKey, FilterItem, FilterPriceValues } from '@/types/filters';
import { WithLang } from '@/types/general';

import { FilterLabelProps } from './calendar-types';

export default function CalendarFilterLabel(props: WithLang<FilterLabelProps>) {
    const { t } = useTranslation(props.lang, 'filters');
    return (
        <>
            {props.options.map((item: FilterItem) => (
                <div
                    key={item.value}
                    className="relative flex items-center justify-between overflow-hidden rounded bg-black bg-opacity-5 px-2 py-1 pl-3"
                >
                    <div className={`absolute left-0 h-full w-1 ${props.className}`} />
                    <p className="mr-2 text-base">
                        {(item.key as EventFilterKey) === 'price'
                            ? t(`priceOptions.${item.display as FilterPriceValues}`)
                            : item.display}
                    </p>
                    <button
                        className="icon h-[10px] w-[10px] cursor-pointer bg-phiX"
                        value={item.display}
                        onClick={() => props.onRemove(item)}
                    />
                </div>
            ))}
        </>
    );
}
